/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateEmbeddingRequest } from '../../models/create-embedding-request';
import { Embedding } from '../../models/embedding';

export interface BulkCreateEmbedding$Params {
      body: Array<CreateEmbeddingRequest>
}

export function bulkCreateEmbedding(http: HttpClient, rootUrl: string, params: BulkCreateEmbedding$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Embedding>>> {
  const rb = new RequestBuilder(rootUrl, bulkCreateEmbedding.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Embedding>>;
    })
  );
}

bulkCreateEmbedding.PATH = '/v0/embeddings/bulk';
